import {
  Button,
  Card,
  Col,
  Form,
  Input,
  InputNumber,
  Row,
  Select,
  Space,
  Switch,
  Tooltip,
  Typography,
} from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import ChevronDown from "@untitled-ui/icons-react/build/esm/ChevronDown";
import React from "react";
import { Util } from "../helper/helper";
import SectionCard from "./SectionCard";

const { Text, Link, Title, Paragraph } = Typography;

export function InstrumentParameters({
  setData,
  data,
  setActivePage,
  activePage,
  setHasModified,
  hasModifed,
  template,
}) {
  const [form] = Form.useForm();
  function onFinish(_data) {
    setData({ ...data, ..._data });
    setActivePage(activePage + 1);
  }
  function goBack() {
    setActivePage(activePage - 1);
  }
  function handleValuesChange() {
    setHasModified && setHasModified([...hasModifed, activePage]);
  }

  React.useEffect(() => {
    form.setFieldsValue({ ...data, redemptionMode: 0 });
  }, [data]);

  const symbol = Util.getSymbol(template, data);
  const minInvestment = Form.useWatch("minInvestment", form);
  const maxInvestment = Form.useWatch("maxInvestment", form);
  const instrument = Form.useWatch("instrumentType", form);

  React.useEffect(() => {
    form.setFieldsValue({
      maxInvestment: minInvestment ? String(minInvestment) : null,
      incrInvestment: minInvestment ? String(minInvestment) : null,
    });
  }, [minInvestment]);
  React.useEffect(() => {
    form.setFieldsValue({
      securityType:
        template?.securityTypes?.find((item) => item.value === 0)?.value ??
        null,
      treasuryBillInterestType:
        template?.interestTypes?.find((item) => item.value === 1)?.value ??
        null,
    });
  }, []);

  console.log(template);
  //
  React.useEffect(() => {
    if (instrument === 515 || instrument === 524 || instrument === 514) {
      form.setFieldValue("issuer", 505);
    } else if (instrument === 525) {
      form.setFieldValue("issuer", 506);
    }
  }, [instrument]);
  return (
    <SectionCard
      onPrev={goBack}
      onNext={form.submit}
      nextTitle={"Next - Pricing & Rate Settings"}
    >
      <Form
        form={form}
        onFinish={onFinish}
        layout="vertical"
        style={{ paddingTop: 0 }}
        onValuesChange={handleValuesChange}
      >
        <Title style={{ margin: 0, marginBottom: 5 }} level={3}>
          Instrument Parameters
        </Title>

        <Space style={{ paddingTop: 40 }} />
        <Row gutter={16} style={{ marginTop: 20 }}>
          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              style={{}}
              name={"instrumentType"}
              rules={[
                {
                  required: true,
                  message: "Please select instrument",
                },
              ]}
              label={
                <Text style={{ color: "#344054" }}>
                  Instrument{" "}
                  <Tooltip>
                    <InfoCircleOutlined
                      title="Instrument info"
                      color="#667085"
                    />
                  </Tooltip>
                </Text>
              }
            >
              <Select
                // size="large"
                options={template.instrumentTypes}
                placeholder={"Select instrument"}
                suffixIcon={<ChevronDown color="#667085" width={20} />}
                className="custom-input"
              />
            </Form.Item>
          </Col>
          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              name="issuer"
              label={
                <Text style={{ color: "#344054" }}>
                  Issuer{" "}
                  <Tooltip>
                    <InfoCircleOutlined title="Issuer info" color="#667085" />
                  </Tooltip>
                </Text>
              }
            >
              <Select
                disabled
                // size="large"
                // options={staticConfig.issuer}
                options={template?.issuers}
                placeholder={"Select issuer"}
                suffixIcon={<ChevronDown color="#667085" width={20} />}
                className="custom-input"
              />
            </Form.Item>
          </Col>
          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              name="securityType"
              rules={[
                {
                  required: true,
                  message: "Please select security type",
                },
              ]}
              label={
                <Text style={{ color: "#344054" }}>
                  Security Type{" "}
                  <Tooltip>
                    <InfoCircleOutlined title="Security info" color="#667085" />
                  </Tooltip>
                </Text>
              }
            >
              <Select
                // size="large"
                // options={staticConfig.securityType}
                options={template?.securityTypes}
                placeholder={"Select security type"}
                suffixIcon={<ChevronDown color="#667085" width={20} />}
                className="custom-input"
              />
            </Form.Item>
          </Col>
          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              name={"tenor"}
              rules={[
                {
                  required: true,
                  message: "Please select tenor",
                },
              ]}
              label={
                <Text style={{ color: "#344054" }}>
                  Tenors Supported{" "}
                  <Tooltip>
                    <InfoCircleOutlined title="Tenor info" color="#667085" />
                  </Tooltip>
                </Text>
              }
            >
              <Select
                // size="large"
                options={template?.tenorOptions}
                placeholder={"Select tenor"}
                suffixIcon={<ChevronDown color="#667085" width={20} />}
                className="custom-input"
              />
            </Form.Item>
          </Col>
          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              rules={[
                {
                  required: true,
                  message: "Enter minimum investment",
                },
                {
                  validator: (_, value) =>
                    value >= 1000
                      ? Promise.resolve()
                      : Promise.reject(
                          new Error(
                            `Default investment must be not be less than 1000`
                          )
                        ),
                },
              ]}
              style={{}}
              name="minInvestment"
              label={
                <Text style={{ color: "#344054" }}>
                  Minimum Investment{" "}
                  <Tooltip>
                    <InfoCircleOutlined
                      title="Minimum investment info"
                      color="#667085"
                    />
                  </Tooltip>
                </Text>
              }
            >
              <InputNumber
                formatter={(value) =>
                  value.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                }
                parser={(value) => (value ? value.replace(/(,*)/g, "") : "")}
                className="custom-input"
                style={{ width: "100%" }}
                // prefix={<div style={{ color: "#344054" }}>₦</div>}
                prefix={<div style={{ color: "#344054" }}>{symbol}</div>}
                // size="large"
                placeholder="50,0000"
              />
            </Form.Item>
          </Col>
          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              name="maxInvestment"
              rules={[
                {
                  required: true,
                  message: "Enter default investment",
                },
                {
                  validator: (_, value) =>
                    value >= 1000 && value >= minInvestment
                      ? Promise.resolve()
                      : Promise.reject(
                          new Error(
                            `Default investment must be not be less than ${minInvestment}`
                          )
                        ),
                },
              ]}
              style={{}}
              label={
                <Text style={{ color: "#344054" }}>
                  Default Investment{" "}
                  <Tooltip>
                    <InfoCircleOutlined
                      title="Product Category info"
                      color="#667085"
                    />
                  </Tooltip>
                </Text>
              }
            >
              <InputNumber
                style={{ width: "100%" }}
                formatter={(value) =>
                  value.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                }
                parser={(value) => (value ? value.replace(/(,*)/g, "") : "")}
                className="custom-input"
                prefix={<div style={{ color: "#344054" }}>{symbol}</div>}
                placeholder="50,0000"
              />
            </Form.Item>
          </Col>

          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              name="incrInvestment"
              rules={[
                {
                  required: true,
                  message: "Enter investment increment",
                },
                {
                  validator: (_, value) =>
                    value >= 1000
                      ? Promise.resolve()
                      : Promise.reject(
                          new Error(
                            `Investment increment must be not be less than 1000`
                          )
                        ),
                },
              ]}
              label={
                <Text style={{ color: "#344054" }}>
                  Investment Increment{" "}
                  <Tooltip>
                    <InfoCircleOutlined
                      title="Investment increment info"
                      color="#667085"
                    />
                  </Tooltip>
                </Text>
              }
            >
              <InputNumber
                disabled
                formatter={(value) =>
                  value.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                }
                parser={(value) => (value ? value.replace(/(,*)/g, "") : "")}
                className="custom-input"
                style={{ width: "100%" }}
                prefix={<div style={{ color: "#344054" }}>{symbol}</div>}
                // size="large"
                placeholder="10,0000"
              />
            </Form.Item>
          </Col>
          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              name="treasuryBillInterestType"
              rules={[
                {
                  required: true,
                  message: "Please select interest type",
                },
              ]}
              label={
                <Text style={{ color: "#344054" }}>
                  Interest Type{" "}
                  <Tooltip>
                    <InfoCircleOutlined
                      title=" Investment Type info"
                      color="#667085"
                    />
                  </Tooltip>
                </Text>
              }
            >
              <Select
                // size="large"
                options={template?.interestTypes}
                placeholder={"Select interest type"}
                suffixIcon={<ChevronDown color="#667085" width={20} />}
                className="custom-input"
              />
            </Form.Item>
          </Col>
          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              name={"redemptionMode"}
              rules={[
                {
                  required: true,
                  message: "Please select redemption mode",
                },
              ]}
              label={
                <Text style={{ color: "#344054" }}>
                  Actual Posting{" "}
                  <Tooltip>
                    <InfoCircleOutlined
                      title="Redemption mode info"
                      color="#667085"
                    />
                  </Tooltip>
                </Text>
              }
            >
              <Select
                disabled
                // size="large"
                options={template?.redemptionModes}
                placeholder={"Select redemption mode"}
                suffixIcon={<ChevronDown color="#667085" width={20} />}
                className="custom-input"
              />
            </Form.Item>
          </Col>
          <Col style={{ marginTop: 35 }}>
            <Row style={{ gap: 10 }}>
              <Col>
                <Form.Item
                  name={"allowEarlyTermination"}
                  style={{ margin: 0, padding: 0 }}
                  valuePropName="checked"
                >
                  <Switch className="custom-switch" />
                </Form.Item>
              </Col>
              <Col style={{ marginTop: 5 }}>
                <Text
                  style={{
                    alignSelf: "center",
                    color: "#667085",
                  }}
                >
                  Allow Early Redemption
                </Text>
              </Col>
            </Row>
          </Col>
          <Col span={12} />
        </Row>
      </Form>
    </SectionCard>
  );
}
